const randomize = require("randomatic");

export default [
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "payer_surname_contains",
      label: "Payer Surname",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "itinerary_reference_contains",
      label: "Itinerary Ref",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "itinerary_internal_ref_contains",
      label: "Itinerary Internal Ref",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () =>
      import("../../shared/list-filters/InternalStatusMultiFilter"),
    props: {
      filterName: "internalStatus_eq",
      label: "Internal Status",
    },
  },

  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "created_by_name_contains",
      label: "Created by",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "client_surname_contains",
      label: "Client Surname",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DepartmentMultiFilter"),
    props: {
      filterName: "departments_eq",
      label: "Department",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/BrandMultiFilter"),
    props: {
      filterName: "brands_eq",
      label: "Brand",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "agent_name_contains",
      label: "Agent",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "lodgement_ref_contains",
      label: "Lodgement Ref",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/BooleanFilter"),
    props: {
      filterName: "exported_eq",
      label: "Exported",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DatesRangeFilter"),
    props: {
      filterName: "created_at",
      label: "Created at date between",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DatesRangeFilter"),
    props: {
      filterName: "lodgement_date",
      label: "Lodgement  date between",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/CurrencyFilter"),
    props: {
      filterName: "currency_eq",
      label: "Currency",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/NumberFilter"),
    props: {
      filterName: "batch_no_eq",
      label: "Batch No",
    },
  },
];



// WEBPACK FOOTER //
// ./src/components/gt/finances/payments/receipts-filters.js